import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmedFilled } from '@one-thd/sui-icons';
import { Tile, TileContent, TileText } from '@one-thd/sui-atomic-components';

const {
  string, shape, bool, func, oneOfType, number
} = PropTypes;

const MultiStateDrawerRefinement = ({
  refinement, onChange, isRefinementSelected
}) => {
  const onMultiItemSelection = (_event, selected) => {
    onChange(_event, selected);
  };

  return (
    <Tile
      grow
      value={refinement.label}
      aria-label={refinement.label}
      onChange={(event) => onMultiItemSelection(event, refinement)}
      selected={isRefinementSelected}
      data-testid="multi-select-refinement"
    >
      <TileContent grow alignItems="start">
        <TileText>
          {refinement.label}
        </TileText>
        { isRefinementSelected && (
          <span className="sui-absolute sui-mr-2 sui-mt-2px sui-right-0">
            <ConfirmedFilled size="small" />
          </span>
        )}
      </TileContent>
    </Tile>
  );
};

MultiStateDrawerRefinement.displayName = 'DrawerRefinement';
MultiStateDrawerRefinement.propTypes = {
  refinement: shape({
    label: string,
    recordCount: oneOfType([string, number]),
    refinementKey: string,
    selected: bool,
    url: string
  }).isRequired,
  onChange: func.isRequired,
  isRefinementSelected: bool
};

MultiStateDrawerRefinement.defaultProps = {
  isRefinementSelected: false
};

export { MultiStateDrawerRefinement };